const CheckupCaption = ({ title, className }) => {
  return (
    <div className={`checkup-caption  ${className ? className : ""} `}>
      <h3 className="title">{title}</h3>
    </div>
  );
};

export default CheckupCaption;
